import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TimelineModule } from 'primeng/timeline';

import { EventoInscricao } from './historico.presenter';

/**
 * Desenho da trajetória de inscrições do médico. Componente burro: recebe eventos prontos do
 * presenter e devolve o índice da linha clicada — quem sabe o que fazer com a seleção é o
 * `Historico`, que já tem as ações e as permissões.
 */
@Component({
    selector: 'app-timeline-inscricoes',
    standalone: true,
    imports: [TimelineModule],
    templateUrl: './timeline-inscricoes.html',
    styleUrl: './timeline-inscricoes.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimelineInscricoes {
    eventos = input.required<EventoInscricao[]>();
    indiceSelecionado = input<number | null>(null);

    /** Índice da linha selecionada, ou `null` quando o clique desmarca o item que já estava ativo. */
    selecionar = output<number | null>();

    protected alternarSelecao(evento: EventoInscricao): void {
        this.selecionar.emit(this.indiceSelecionado() === evento.indiceLinha ? null : evento.indiceLinha);
    }
}
